import { Col, Divider, Row } from "antd"

export const PerfilJurado = ({ jurado, areaPrincipal }: any) => {


    return (
        <Row style={{ padding: '20px' }} gutter={[24, 24]} >
            <Col span={24}>
                <div className="font-size-12px font-family-Montserrat-SemiBold">Descripción del perfil</div>
                <Divider style={{ margin: '2px' }} />
                <p className="font-family-Work-Sans font-size-12px font-color-535353" >{jurado.perfil}</p>
            </Col>
            <Col span={24}>
                <div className="font-size-12px font-family-Montserrat-SemiBold">Área principal de conocimiento</div>
                <Divider style={{ margin: '2px' }} />
                <p className="font-family-Work-Sans font-size-12px font-color-535353" >{areaPrincipal}</p>
            </Col>

            <Col span={24} >
                <div className="font-size-12px font-family-Montserrat-SemiBold">Categorías de conocimiento</div>
                <Divider style={{ margin: '2px' }} />
                <ul className="font-color-051923bf" style={{ paddingLeft: '14px' }}>
                    {jurado.areas_conocimientos[0].areas_conocimientos.map((x: any) =>
                        <li className="font-family-Work-Sans font-size-12px font-color-051923bf " key={x.id}>
                            <span className="font-color-535353">{x.nombre}</span>
                        </li>
                    )}
                </ul>
            </Col>
        </Row>
    )
}
